import { ModuleItemProps } from "apis";
import { lazy } from "react";

export const PageAdminModule = lazy(() => import("./List"));
export const PageAdminModuleCreate = lazy(() => import("./Add"));
export const PageAdminModuleUpdate = lazy(() => import("./Edit"));

export interface FormModuleValuesProps extends ModuleItemProps {
}